const Button = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="white" />
      <path
        d="M25.9998 18.8037C27.0665 19.4243 27.0665 20.9757 25.9998 21.5963L16.3998 27.1816C15.3331 27.8022 13.9998 27.0264 13.9998 25.7853L13.9998 14.6147C13.9998 13.3736 15.3331 12.5978 16.3998 13.2184L25.9998 18.8037Z"
        fill="#FD8533"
      />
    </svg>
  );
};

export default Button;
